import React from 'react';
import styled from 'styled-components';
import { ServiceInfo } from '../../util/services';

interface Props {
  service: ServiceInfo;
}

const Wrapper = styled.a`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  font-weight: 500;
  text-align: center;
  color: #352e27;
  border: 10px solid #fcf8f6;
  flex: 0 1 calc(25%);
`;

const Button = styled.div`
  display: flex;
  width: 100px;
  height: 100px;
  padding: 10px;
  border-radius: 2px;
  box-shadow: 0 1px 1px 0 rgba(63, 63, 68, 0.1);
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
`;

const ServiceItem = (props: Props) => {
  const { service } = props;

  return (
    <Wrapper href={service.siteUrl}>
      <Button>
        <Image alt={service.name} src={`${process.env.REACT_APP_BASE_URL}${service.imageUrl}`} />
      </Button>
      <p>{service.name}</p>
    </Wrapper>
  );
};

export default ServiceItem;
